import React, { useEffect } from "react";

import PropTypes from "prop-types";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";

// Import page components
import Affiliates from "./Pages/Affiliates";
import AllUser from "./Pages/AllUser/index";
import BytescareRequests from "./Pages/Bytescare";
import CertificatesSection from "./Pages/CertificatesSection";
import CouponSection from "./Pages/CouponSection";
import CreatorAccess from "./Pages/CreatorAccess";
import CreatorEarnings from "./Pages/CreatorEarnings";
import CreatorsFunnel from "./Pages/CreatorFunnel";
import CreatorPayables from "./Pages/CreatorPayables";
import DashboardAccess from "./Pages/DasboardAccess";
import DashboardBanner from "./Pages/DashboardBanner";
import EmailSection from "./Pages/EmailSection";
import EnterpriseCreators from "./Pages/EnterpriseCreators";
import FreedomCreators from "./Pages/FreedomCreators";
import FrontendReleases from "./Pages/FrontendReleases";
import Home from "./Pages/HomePage/index";
import Invoices from "./Pages/Invoices";
import LandingPageTemplates from "./Pages/LandingPageTemplates/LandingPageTemplates";
import ManageFeatures from "./Pages/ManageFeatures/ManageFeatures";
import ManagePlanRequests from "./Pages/ManagePlanRequests";
import MangoCreditTransactions from "./Pages/MangoCreditTransactions";
import Migration from "./Pages/Migration";
import NoAccountUser from "./Pages/NoAccountUser/index";
import NonTransferredPayment from "./Pages/NonTransferredPayment/index";
import OnboardingDetails from "./Pages/OnboardingDetails";
import OrderDetailsV2 from "./Pages/OrderDetailsV2/index";
import PaymentTerms from "./Pages/PaymentTerms";
import PayoutsSchedule from "./Pages/PayoutsSchedule";
import PushNotifications from "./Pages/PushNotifications";
import RefernEarnEarnings from "./Pages/RefernEarnEarnings";
import RefernEarnNonEarningPartners from "./Pages/RefernEarnNonEarningPartners";
import RefernEarnOrders from "./Pages/RefernEarnOrders";
import RefernEarnPartners from "./Pages/RefernEarnPartners";
import RefernEarnPayouts from "./Pages/RefernEarnPayouts";
import RefernEarnProducts from "./Pages/RefernEarnProducts";
import RefernEarnRequests from "./Pages/RefernEarnRequests";
import Refunds from "./Pages/Refunds";
import TagmangoCreators from "./Pages/TagmangoCreators";
import TaxReports from "./Pages/TaxReports";
import TierOrders from "./Pages/TierOrders";
import UpcomingMangos from "./Pages/UpcomingMangos";
import UserDetails from "./Pages/UserDetails";
import UserDetailsList from "./Pages/UserDetailsList/index";
import UserKYCList from "./Pages/UserKYCList/UserKYCList";
import IndianWalletWithdrawals from "./Pages/WalletWithdrawals/indian";
import InternationalWalletWithdrawals from "./Pages/WalletWithdrawals/international";
import USDWalletWithdrawals from "./Pages/WalletWithdrawals/usd";
import WhatsappManagement from "./Pages/WhatsappManagement";
import WhitelabelHome from "./Pages/WhitelabelHome";
import WithdrawalsSection from "./Pages/WithdrawalsSection";
import {
  getSliderKeyByRoute,
  MENU_STRUCTURE,
  ROUTE_PATHS,
} from "./routeConstants";
import CsDashboard from "./Pages/CsDashboard";
import SalesDashboard from "./Pages/Sales/index";
import ManageSale from "./Pages/Sales/ManageSale";
import MangoConfig from "./Pages/MangoConfig";
import CreatorList from "./Pages/Creator/CreatorList";
import Transactions from "./Pages/Transactions";
import UtmParameters from "./Pages/UtmParameters";
import ManualPayments from "./Pages/ManualPayments";

// Component mapping for dynamic route generation
const COMPONENT_MAP = {
  // Home
  home: Home,
  whitelabelHome: WhitelabelHome,

  // User Management
  allUser: AllUser,
  noAccountUser: NoAccountUser,
  userDetailsList: UserDetailsList,
  userKYCList: UserKYCList,

  // Creator Management
  csDashboard: CsDashboard,
  tagmangoCreators: TagmangoCreators,
  freedomCreators: FreedomCreators,
  enterpriseCreators: EnterpriseCreators,
  creatorAccess: CreatorAccess,
  creatorEarnings: CreatorEarnings,
  creatorPayables: CreatorPayables,
  creatorsFunnel: CreatorsFunnel,

  // Orders & Payments
  orderDetails: OrderDetailsV2,
  refunds: Refunds,
  tierOrdersV2: RefernEarnOrders,

  // Financial Management
  widthdrawalsSection: WithdrawalsSection,
  indianWalletWithdrawals: IndianWalletWithdrawals,
  internationalWalletWithdrawals: InternationalWalletWithdrawals,
  usdWalletWithdrawals: USDWalletWithdrawals,
  taxReports: TaxReports,
  mangoCreditTransactions: MangoCreditTransactions,
  invoices: Invoices,
  affiliateEarnings: Affiliates,

  // Refer & Earn
  refernEarnRequests: RefernEarnRequests,
  refernEarnProducts: RefernEarnProducts,
  refernEarnPartners: RefernEarnPartners,
  refernEarnNonEarningPartners: RefernEarnNonEarningPartners,
  refernEarnPayouts: RefernEarnPayouts,

  // Content & Marketing
  upcomingMangos: UpcomingMangos,
  landingPageTemplates: LandingPageTemplates,
  couponSection: CouponSection,

  // Communication
  pushNotifications: PushNotifications,
  emailSection: EmailSection,
  whatsappManagement: WhatsappManagement,

  // Administration
  dashboardAccess: DashboardAccess,
  manageFeatures: ManageFeatures,
  dashboardBanner: DashboardBanner,
  onboardingDetails: OnboardingDetails,
  managePlanRequests: ManagePlanRequests,

  // System & Tools
  bytescareRequests: BytescareRequests,
  migration: Migration,
  frontendReleases: FrontendReleases,
};

// Additional routes not in menu structure (parameterized or special routes)
const ADDITIONAL_ROUTES = [
  {
    path: ROUTE_PATHS.USER_DETAILS,
    component: UserDetails,
    exact: true,
  },
  {
    path: ROUTE_PATHS.NON_TRANSFERRED,
    component: NonTransferredPayment,
    exact: true,
  },
  {
    path: ROUTE_PATHS.PAYMENT_TERMS,
    component: PaymentTerms,
    exact: true,
  },
  {
    path: ROUTE_PATHS.PAYOUTS_SCHEDULE,
    component: PayoutsSchedule,
    exact: true,
  },
  {
    path: ROUTE_PATHS.CERTIFICATES_SECTION,
    component: CertificatesSection,
    exact: true,
  },
  {
    path: ROUTE_PATHS.REFERN_EARN_EARNINGS,
    component: RefernEarnEarnings,
    exact: true,
  },
  {
    path: ROUTE_PATHS.TIER_ORDERS,
    component: TierOrders,
    exact: true,
  },
  {
    path: ROUTE_PATHS.SALES_DASHBOARD,
    component: SalesDashboard,
    exact: true,
  },
  {
    path: `${ROUTE_PATHS.SALES_DASHBOARD}/:saleId`,
    component: ManageSale,
    exact: true,
    // Parameterized path, so getSliderKeyByRoute cannot resolve it and would
    // fall back to "home". Gate it on the Sales Dashboard permission instead.
    sliderKey: "salesDashboard",
  },
  {
    path: ROUTE_PATHS.MANGO_CONFIG,
    component: MangoConfig,
    exact: true,
  },
  {
    path: ROUTE_PATHS.CREATOR_LIST,
    component: CreatorList,
    exact: true,
  },
  {
    path: ROUTE_PATHS.TRANSACTIONS,
    component: Transactions,
    exact: true,
  },
  {
    path: ROUTE_PATHS.UTM_PARAMETERS,
    component: UtmParameters,
    exact: true,
  },
  {
    path: ROUTE_PATHS.MANUAL_PAYMENTS,
    component: ManualPayments,
    exact: true,
  },
];

/**
 * Generate route configuration dynamically from MENU_STRUCTURE
 *
 * This function creates the ROUTE_CONFIG array by:
 * 1. Iterating through MENU_STRUCTURE to extract all menu items
 * 2. Mapping each menu item's key to its corresponding React component via COMPONENT_MAP
 * 3. Creating route objects with path, component, and exact properties
 * 4. Adding ADDITIONAL_ROUTES for routes not in the menu (parameterized, special routes)
 * 5. Including a fallback route to home
 *
 * Benefits:
 * - Single source of truth: Add/remove routes by modifying MENU_STRUCTURE only
 * - Automatic route generation: No need to manually maintain both menu and routes
 * - Consistent ordering: Routes follow the same order as menu structure
 *
 * To add a new route:
 * 1. Add the route path to ROUTE_PATHS in routeConstants.jsx
 * 2. Add the menu item to appropriate section in MENU_STRUCTURE
 * 3. Add the route -> permission key entry to ROUTE_TO_SLIDER_MAP in routeConstants.jsx
 * 4. Add the component mapping to COMPONENT_MAP above
 * 5. Import the component at the top of this file
 * 6. REQUIRED: add { key, name } to AVAILABLE_PAGES in Utils/constants.js, using
 *    the SAME key as the menu item. AVAILABLE_PAGES is the only list that feeds
 *    the "Allowed Functions" dropdown on the Dashboard Access page, so a key that
 *    is missing from it can never be granted to anyone: ProtectedRoute keeps
 *    denying the page and Sider keeps hiding it for every restricted admin, with
 *    no way to fix it from the UI. This step is easy to forget because the route
 *    works fine for unrestricted admins - it only breaks for restricted ones.
 *
 * For a parameterized route (e.g. /thing/:id), ROUTE_TO_SLIDER_MAP cannot help:
 * getSliderKeyByRoute matches the pathname exactly and falls back to "home", so
 * the route ends up gated by the wrong permission. Declare the key explicitly on
 * the ADDITIONAL_ROUTES entry instead - see `sliderKey` on the sale detail route.
 *
 * @returns {Array} Array of route configuration objects
 */
const generateRouteConfig = () => {
  const menuRoutes = [];

  // Extract all routes from MENU_STRUCTURE
  MENU_STRUCTURE.forEach((section) => {
    if (section.items) {
      section.items.forEach((item) => {
        const component = COMPONENT_MAP[item.key];
        if (component && item.route) {
          menuRoutes.push({
            path: item.route,
            component,
            exact: true,
          });
        }
      });
    }
  });
  // console.log({ menuRoutes });
  // Combine with additional routes and add fallback
  return [
    ...menuRoutes,
    ...ADDITIONAL_ROUTES,
    // Default fallback to home (should be last)
    {
      path: ROUTE_PATHS.DASHBOARD,
      component: Home,
      exact: false,
    },
  ];
};

// Route configuration mapping paths to components
export const ROUTE_CONFIG = generateRouteConfig();

// Protected Route Component
const ProtectedRoute = ({
  component: Component,
  isRestricted,
  allowedFunctions,
  sensitiveAllowedActions,
  setSliderValue,
  sliderKey: sliderKeyOverride = null,
  ...rest
}) => {
  const history = useHistory();
  const location = useLocation();

  // Parameterized routes cannot be resolved from the path, so they declare their
  // permission key explicitly in the route config.
  const sliderKey = sliderKeyOverride || getSliderKeyByRoute(location.pathname);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      history.push("/login");
      return;
    }

    // Update slider value based on current route for backward compatibility
    if (setSliderValue && sliderKey) {
      setSliderValue(sliderKey);
    }
  }, [location.pathname, history, setSliderValue, sliderKey]);

  const renderComponent = (props) => {
    // Check if user has access to this page when restricted
    if (isRestricted && !allowedFunctions.includes(sliderKey)) {
      return (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h3>Access Denied</h3>
          <p>You don&apos;t have permission to view this page.</p>
        </div>
      );
    }

    return (
      <Component
        {...props}
        isRestricted={isRestricted}
        allowedFunctions={allowedFunctions}
        sensitiveAllowedActions={sensitiveAllowedActions}
        setSliderValue={setSliderValue}
      />
    );
  };

  return <Route {...rest} render={renderComponent} />;
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isRestricted: PropTypes.bool.isRequired,
  allowedFunctions: PropTypes.arrayOf(PropTypes.string).isRequired,
  sensitiveAllowedActions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSliderValue: PropTypes.func,
  sliderKey: PropTypes.string,
};

// Dashboard Router Component
const DashboardRouter = ({
  isRestricted,
  allowedFunctions,
  sensitiveAllowedActions,
  setSliderValue,
}) => {
  return (
    <Switch>
      {ROUTE_CONFIG.map((route) => (
        <ProtectedRoute
          key={route.path}
          exact={route.exact}
          path={route.path}
          component={route.component}
          isRestricted={isRestricted}
          allowedFunctions={allowedFunctions}
          sensitiveAllowedActions={sensitiveAllowedActions}
          setSliderValue={setSliderValue}
          sliderKey={route.sliderKey}
        />
      ))}
    </Switch>
  );
};

DashboardRouter.propTypes = {
  isRestricted: PropTypes.bool.isRequired,
  allowedFunctions: PropTypes.arrayOf(PropTypes.string).isRequired,
  sensitiveAllowedActions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSliderValue: PropTypes.func,
};

export default DashboardRouter;
